<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row">
          <div class="col-md-12">
              <div class="top-list-small-toolbar">
                  <div>
                      <h4 class="text-primary">Sale Order Monitoring</h4>
                      <div class="form-inline">
                        <span><b>Company:</b></span>
                        <select v-model="company_no" class="form-control">
                          <option value="">-- All --</option>
                          <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                        </select>
                        <span><b>Salesman:</b></span>
                        <v-select :options="getUserSalesman" :reduce="salesman => salesman.meta.code" label="salesman" v-model="salesman_id" class="vsc-custom vsc-custom-inline"/>
                        <span><b>Area:</b></span>
                        <select v-model="area" class="form-control">
                          <option value="">-- All --</option>
                          <option v-for="a in areaList" :key="a.id" :value="a.name">{{ a.name }}</option>
                        </select>
                        <button type="button" class="btn btn-sm  btn-hard-primary waves-light waves-effect" @click="refreshList">
                          <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                        </button>
                        <button type="button" class="btn btn-sm  btn-warning waves-light waves-effect" @click="recalculateSaldo">
                          <i class="fa fa-refresh" aria-hidden="true"></i> Recalculate Saldo
                        </button>
                          <!-- <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery" /> -->
                        <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i class="fa fa-print" aria-hidden="true"></i> Print
                        </button>
                        <div class="dropdown-menu" aria-labelledby="print">
                          <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                          <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
              <div class="card card-list">
                  <div class="card-body">
                      <div class="table-responsive">
                          <table class="table table-item mb-0 table-sm table-striped table-hover">
                              <thead>
                                  <th colspan="2">Order No.</th>
                                  <th>Order Date</th>
                                  <th>Customer</th>
                                  <th>Area</th>
                                  <th class="text-center">Salesman</th>
                                  <th>Product</th>
                                  <th class="text-right">Price</th>
                                  <th class="text-center">Uom</th>
                                  <th class="text-center">Order</th>
                                  <th class="text-center">Done</th>
                                  <th class="text-center">Remaining</th>
                                  <th class="text-center">Saldo</th>
                              </thead>
                              <tbody>
                                  <tr v-for="i in dataRaw" :key="i.id">
                                      <td><b>{{ i.project_name }}</b></td>
                                      <td>
                                        <span class="text-ref-sales" data-toggle="modal" data-target="#modalSaleOrderByNo" data-backdrop="static" data-keyboard="false" @click="showOrderNo(i.order_no)">{{ i.order_no }}</span>
                                      </td>
                                      <td>{{ i.order_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ i.customer }}</td>
                                      <td>{{ i.area }}</td>
                                      <td class="text-center">
                                          <span v-if="i.salesman_id">{{ i.salesman }}</span>
                                      </td>
                                      <td><b>[{{ i.product_no}}]</b> {{ i.product }}</td>
                                      <td class="text-right">{{ i.subtotal | currency }}</td>
                                      <td class="text-center">{{ i.uom_id }}</td>
                                      <td class="text-center">{{ i.qty }}</td>
                                      <td class="text-center">{{ i.qty_done }}</td>
                                      <td class="text-center">{{ i.qty_remaining }}</td>
                                      <td class="text-center">
                                        <span v-if="i.saldo_uom_id === null">
                                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        </span>
                                        <span v-else>{{ i.saldo }} {{ i.saldo_uom_id }}</span>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <!-- <pre>
          {{ dataRaw }}
        </pre> -->
        <SalesOrderModal />
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { productUrl, reportUrl, getHeader, sale2Url } from '@/config'
import SalesOrderModal from '@/components/sales/SaleOrderModal.vue'

export default {
  name: 'SaleOrderMonitoring',
  props: ['scroll'],
  components: {
    Loading,
    SalesOrderModal
  },
  data () {
    var date = new Date()
    return {
      area: '',
      selected: [],
      startDate: [date, date],
      term: 0,
      salesman_id: '',
      company_no: '',
      year: '2022',
      date: null,
      typeData: null,
      period: [],
      dataRaw: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getEmployeeList')
    this.$store.dispatch('getAreaList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      employeeList: state => state.employees.employeeList,
      areaList: state => state.area.areaList
    }),
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = [{
        salesman: '-- All --',
        meta: {
          code: ''
        }
      }]
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    showOrderNo (no) {
      var payload = {
        order_no: no
      }
      this.$store.dispatch('getOrderByNo', payload)
    },
    async recalculateSaldo () {
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var obj = {
          product_no: array[i].product_no,
          date: null
        }
        await axios.post(productUrl + '/cost/get-saldo', obj, { headers: getHeader() })
          .then(response => {
            array[i].saldo = response.data.data.qty
            array[i].saldo_uom_id = response.data.data.uom_id
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            array[i].saldo = 0
            array[i].saldo_uom_id = ''
          })
      }
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      var obj = {
        company_no: this.company_no,
        salesman: this.salesman_id,
        area: this.area
      }
      console.log(obj)
      await axios.post(reportUrl + '/sale-order-monitoring', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.recalculateSaldo()
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.dataRaw
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await axios.post(sale2Url + '/sale-order-monitoring', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
.text-ref-sales {
    color: #28A745;
    cursor: pointer;
}
</style>
